import { render } from "./bulk.vue?vue&type=template&id=6e029efe&ts=true"
import script from "./bulk.vue?vue&type=script&lang=ts&config=true"
export * from "./bulk.vue?vue&type=script&lang=ts&config=true"

import "./bulk.vue?vue&type=style&index=0&id=6e029efe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__